/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import _, { set } from "lodash";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Button,
  Snackbar,
  Alert,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import swal from "sweetalert";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ apCompanies, missingPermissions, plates }) {
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  const [selectedAPCompany, setSelectedAPCompany] = useState(null);
  //   const [apUsers, setApUsers] = useState(null);
  //   const [jobs, setJobs] = useState(null);
  const [apCompany, setApCompany] = useState(null);
  const [plate, setPlate] = useState(null);
  const [plateQuantity, setPlateQuantity] = useState(null);
  const [requiredQuantity, setRequiredQuantity] = useState(null);
  const [sourceCompany, setSourceCompany] = useState({});
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const [transactionType, setTransactionType] = useState(null);

  useEffect(() => {

    const fetchPlateQuantity = async () => {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      try {
        const { data } = await axios.get(
          `/api/v1/${userData.type}/plate_inventory/plate_detail/${sourceCompany._id}/${plate._id}`,
          config
        );
        if (data.success) {
          setPlateQuantity(data?.data[0]?.quantity || 0);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (plate && sourceCompany) {
      fetchPlateQuantity();
    }

    // if (sourceCompany === null) {
    //   setErr("Reselect Source AP Company");
    //   snackRef.current.click();
    // }
  }, [sourceCompany, plate, transactionType]);


  const submit = async (values, resetForm) => {
    try {
      //   setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/plate_inventory/inward_outward`,
        {
          ap_company: values.ap_company,
          plate: values.plate,
          entry_type: values.entry_type,
          quantity: values.quantity,
          remarks: values.remarks,
          source_company: values.source_company,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        setRows([]);
        navigate("/dashboard/inventory/in-out", {
          state: { success: true, message: "Request Created Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
      snackRef.current.click();
    }
  };

  useEffect(() => {
    console.log(err);
  }, [err]);

  return (
    <>
      <Formik
        initialValues={{
          ap_company: "",
          plate: "",
          quantity: "",
          remarks: "",
          entry_type: "",
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          ap_company: Yup.string().required("Ap Company is required"),
          plate: Yup.string().required("Plate is required"),
          quantity: Yup.number().required("Quantity is required"),
          entry_type: Yup.string().required("Entry Type is required"),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          // <></>
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Request created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Create In/Out Request
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.plate && errors.plate)}
                        >
                          <Autocomplete
                            id="search-field"
                            options={plates}
                            getOptionLabel={(plate) =>
                              `${plate.height}X${plate.width}X${plate.thickness} || ${plate.brand.name} || ${plate.technology.name} || ${plate.company}`
                            }
                            value={plates.find((p) => p._id === values.plate) || null}
                            onChange={(event, newValue) => {
                              setFieldValue("plate", newValue ? newValue._id : "");
                              setPlate(newValue);
                            }}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            renderInput={(params) => (
                              <TextField {...params} label="Select Plate" variant="outlined" />
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: '200px',
                              },
                            }}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.entry_type && errors.entry_type)}
                        >
                          <Autocomplete
                            id="entry-type-autocomplete"
                            options={[
                              { label: "Inward", value: "inward", color: "#33B897" },
                              { label: "Outward", value: "outward", color: "tomato" },
                            ]}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value}
                            value={
                              [{ label: "Inward", value: "inward" }, { label: "Outward", value: "outward" }]
                                .find((opt) => opt.value === values?.entry_type) || null
                            }
                            onChange={(e, newValue) => {
                              setFieldValue("entry_type", newValue ? newValue.value : "");
                              setSourceCompany(null);
                              setTransactionType(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={values.entry_type === "inward" ? "Receiver AP's transaction type *" : "Source AP's transaction type *"}
                                variant="outlined"
                                error={Boolean(touched.entry_type && errors.entry_type)}
                                helperText={touched.entry_type && errors.entry_type}
                              />
                            )}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Typography style={{ color: option.color }}>{option.label}</Typography>
                              </li>
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(
                            touched.ap_company && errors.ap_company
                          )}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={apCompanies}
                            value={values?.ap_company?.name}
                            onChange={(event, newValue) => {
                              setFieldValue("ap_company", newValue?._id || "");
                              setSelectedAPCompany(newValue);
                              setApCompany(newValue);

                              console.log(values.entry_type);

                              if (values.entry_type !== "inward") {
                                setSourceCompany(newValue);
                              }
                            }}
                            inputValue={values?.ap_company?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  touched.ap_company && errors.ap_company
                                )}
                                helperText={
                                  touched.ap_company && errors.ap_company
                                }
                                label={values.entry_type === "inward" ? "Receiver AP Company *" : "Source AP Company *"}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                        // error={Boolean(
                        //   touched.ap_company && errors.ap_company
                        // )}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={apCompanies.filter((company) => {
                              return company._id !== selectedAPCompany?._id;
                            })}
                            value={values?.ap_company?.name}
                            onChange={(event, newValue) => {
                              setFieldValue("source_company", newValue?._id || "");
                              if (values.entry_type === "inward") {
                                setSourceCompany(newValue);
                              }
                            }}
                            inputValue={values?.ap_company?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // error={Boolean(
                                //   touched.ap_company && errors.ap_company
                                // )}
                                // helperText={
                                //   touched.ap_company && errors.ap_company
                                // }
                                label={values.entry_type === "inward" ? "Source AP Company" : "Receiver AP Company"}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          type="number"
                          fullWidth
                          name="quantity"
                          value={values.quantity}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.quantity && errors.quantity)}
                          id="search-field"
                          label="Quantity * "
                          helperText={touched.quantity && errors.quantity}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="remarks"
                          value={values.remarks}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.remarks && errors.remarks)}
                          id="search-field"
                          label="Remarks"
                          helperText={touched.remarks && errors.remarks}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={
                            isSubmitting ||
                            missingPermissions.length > 0 ||
                            (values.quantity != null && plateQuantity != null && values.quantity > plateQuantity)
                          }
                        >
                          Create Request
                        </Button>
                        <Typography fontSize={12} color="red">
                          {values.quantity != null && plateQuantity != null && values.quantity > plateQuantity ? `Quantity cannot be greater than ${plateQuantity}` : null}
                        </Typography>
                        {/* <Button
                          style={{ textAlign: "center", background: "red" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                        >
                          Reset
                        </Button> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getApCompaniesAndPlates = async (
  setApCompanies,
  setPlates,
  setLoader
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    let url = `/api/v1/${userData?.type}/plate_inventory/inward_outward/ap_companies?page=1&limit=1000`;

    const apCompanies = await axios.get(url, config);
    if (apCompanies.data.success) {
      let finalData = apCompanies.data.data;
      setApCompanies(finalData);
    }
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory?limit=1000`,
      config
    );
    if (data.success) {
      setPlates(data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function CreateInOut({ auths }) {
  const [plates, setPlates] = useState([]);
  const [apCompanies, setApCompanies] = useState([]);

  const [loader, setLoader] = useState(true);
  const [apUsers, setApUsers] = useState([]);

  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = ["view_plate_list", "view_in_out"];

  useEffect(() => {
    if (auths?.user) {
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(", ").replace(/_/g, " "))}
            `,
            "error"
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [auths.user]);

  useEffect(() => {
    getApCompaniesAndPlates(setApCompanies, setPlates, setLoader);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CREATE IN-OUT
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Link component={NavLink} to="/dashboard/inventory/in-out">
                In-Out
              </Link>
              <Typography>Create</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              missingPermissions={missingPermissions}
              apCompanies={apCompanies}
              plates={plates}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CreateInOut);
